import { useRouter } from "next/router";

export default function useQueryParam(paramName: string) {
  const router = useRouter();
  return router.query[paramName];
}
